import { Outlet } from "react-router-dom";

import { FilterServiceProvider } from "./filter-service/filter-service.context";
import './service.scss';

export function Service() {
  return (
    <div id="ShellService" className="service">
       <FilterServiceProvider>
        <Outlet />
      </FilterServiceProvider>
    </div>
  );
}

export default Service;
